import directives from './module';
import {AnimatronProjectsFactory, AnimatronProjects} from '../services/AnimatronProjectsSvc';
import {Utils} from '../underscore-extensions';

export class OpenEditor implements ng.IComponentController {
    isUpgradeDialog: boolean;
    className: string;
    private params: anm.OpenEditorParams;
    private projectId: string;
    private action: 'create' | 'edit' | 'duplicate' | 'openVideoTemplates';
    private videosCount: number;

    constructor(private $state: ng.ui.IStateService,
                private AnimatronProjects: AnimatronProjectsFactory) {
        this.action = this.action || 'openVideoTemplates';
    }

    clickHandler() {
        switch (this.action) {
            case 'create':
                this.createNew();
                break;

            case 'openVideoTemplates':
                this.openVideoTemplates();
                break;

            case 'edit':
                this.edit();
                break;

            case 'duplicate':
                this.duplicate();
                break;
        }
    }

    goUpgrade() {
        this.$state.go('wave-pricing').then(() => this.isUpgradeDialog = false);
    }

    private edit() {
        if (this.canOpen && this.projectId) {
            window.open(`${options.waveEditorDomain}#p=${this.projectId}`, '_blank');
        }
    }

    private duplicate() {
        if (this.canOpen && this.projectId) {
            window.open(`${options.waveEditorDomain}#d=${this.projectId}`, '_blank');
        }
    }

    private createNew() {
        let query = '';
        if (this.params) {
            query = Utils.toParams(this.params);
            query = `&${query}`;

        }

        this.setVideosCount().then(() => {
            if (this.canCreate) {
                if (this.canOpen) {
                    window.open(`${options.waveEditorDomain}#new=1${query}`, '_self');
                }
            } else {
                this.isUpgradeDialog = true;
            }
        });
    }

    private openVideoTemplates() {
        this.$state.go('video-templates');
    }

    private setVideosCount() {
        const params: ProjectSearchCriteria = {
            product: 'WAVE',
            offset: 0,
            limit: 0
        };

        const animatronProjects = new AnimatronProjects(params, true);
        return animatronProjects.nextPage().then(() => this.videosCount = animatronProjects.count);
    }

    private get canOpen() {
        if (options.handHeld) {
            this.$state.go('editor-redirect');
            return false;
        }

        return true;
    }

    private get canCreate() {
        return this.details.name !== 'WaveFree' || this.videosCount < this.videosLimit;
    }

    private get details() {
        return options.user.subscriptionDetails.wave;
    }

    private get videosLimit() {
        return this.details.features.PrivateUnlistedProjects.numProjects;
    }
}

directives.component('openEditor', {
    bindings: {
        className: '@',
        action: '@?',
        params: '<',
        projectId: '<?'
    },
    transclude: true,
    controller: OpenEditor,
    templateUrl: require('open-editor.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/OpenEditor.ts